import request from '@/utils/request'

export type activityInfoRequest = {
  body: {
    activityName: string
  }
}
export type activityTicketDetailRequest = {
  body: {
    activityId: string
  }
}
export type receiveTicketRequest = {
  body: {
    activityId: string
    code: string
    activityName: string
  }
}

export type activityInfoResponse = {
  result: {
    trafficData: string
    remainNumber: number
    prizeList: []
    monthTotalNum: number
    monthRedeemNum: number
  }
}
export type activityTicketListResponse = {
  result: {
    ticket: []
  }
}
export type activityTicketDetailResponse = {
  result: {
    ticket: []
  }
}
export type checkInfoResponse = {
  result: boolean,
  resultMsg: string
}
export type receiveTicketResponse = {
  result: boolean
}
//获取权益信息
export function getActivityInfo(data: activityInfoRequest) {
  return request<activityInfoResponse>({
    url: '/v1/api/user/ticketBag/ticket/activityInfo',
    method: 'post',
    data
  })
}
// 是否大湾区资格
export function checkInfo() {
  return request<checkInfoResponse>({
    url: '/v1/api/user/ticketBag/ticket/activity/5GBAYAREA/check',
    method: 'post'
  })
}
//获取商家券
export function getActivityTicketList(data: activityInfoRequest) {
  return request<activityTicketListResponse>({
    url: '/v1/api/user/ticketBag/ticket/activityTicketList',
    method: 'post',
    data
  })
}
//获取券详情
export function getActivityTicketDetail(data: activityTicketDetailRequest) {
  return request<activityTicketDetailResponse>({
    url: '/v1/api/user/ticketBag/ticket/activityTicketDetail',
    method: 'post',
    data
  })
}
//兑换
export function receiveTicket(data: receiveTicketRequest) {
  return request<receiveTicketResponse>({
    url: '/v1/api/user/ticketBag/ticket/receive',
    method: 'post',
    data
  })
}
